import { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiDialog: Components<CssVarsTheme>['MuiDialog'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: '1rem',
      boxShadow: theme.vars.customShadow.secondary.center
    }),
    scrollPaper: ({ theme }) => ({
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        alignItems: 'flex-start'
      }
    })
  }
};

export const MuiDialogTitle: Components<CssVarsTheme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '1.5rem',
      [theme.breakpoints.down('md')]: {
        padding: '1rem'
      },
      borderBottom: `1.5px solid ${theme.vars.palette.neutral[0]}`,
      fontSize: '1.25rem',
      fontWeight: 600
    })
  }
};
export const MuiDialogContent: Components<CssVarsTheme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '1.5rem',
      [theme.breakpoints.down('md')]: {
        padding: '1rem'
      }
    })
  }
};

export const MuiDialogActions: Components<CssVarsTheme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '1.5rem',
      borderTop: `1.5px solid ${theme.vars.palette.neutral[0]}`,
      fontSize: '1.25rem',
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        padding: '1rem'
      }
    })
  }
};
